/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import { getScaledValue } from '../../ui/styled';
import Icons from './../../assets/icons';

// react-native-web-linear-gradient renders a View with a programmatic
// `backgroundImage: linear-gradient(...)` style — react-native-web-safe (no
// CSS `background-image:` declaration for css-to-react-native to choke on, which
// crashed the SPA). Mirrors packages/mobile/src/components/LinearGradient.
import LinearGradient from 'react-native-web-linear-gradient';

// import {
//     getScaledValue
// } from 'renative';

export const ContentBanner = styled.ImageBackground.attrs({})`
  position: relative;
  height: ${getScaledValue(220)}px;
  background-color: rgba(255, 255, 255, 0.2);
`;
// Left-to-right black fade over the banner art. Gradient comes from the
// component's props (programmatic style), not a `background-image:` CSS
// declaration (unparseable by css-to-react-native — it crashed the SPA).
export const BannerDecoration = styled(LinearGradient).attrs({
  colors: ['rgba(0, 0, 0, 0.7)', 'rgba(0, 0, 0, 0.1)'],
  start: { x: 0, y: 0.5 },
  end: { x: 1, y: 0.5 },
})`
  position: absolute;
  height: ${getScaledValue(220)}px;
  width: 100%;
`;
export const BannerContent = styled.View.attrs({})`
  background-color: rgba(0, 0, 0, 0.25);
  height: ${getScaledValue(220)}px;
  padding: ${getScaledValue(20)}px;
`;
export const BannerRowOptions = styled.View.attrs({})`
  flex-direction: row;
`;
export const BannerContentTitle = styled.Text.attrs({})`
  font-size: ${getScaledValue(24)}px;
  color: #ffffff;
  font-family: PTSans-Bold;
  margin-bottom: ${getScaledValue(12)}px;
`;
export const BannerContentText = styled.Text.attrs({
  numberOfLines: 6,
})`
  font-size: ${getScaledValue(10)}px;
  line-height: ${getScaledValue(13)}px;
  color: #ffffff;
  font-family: PTSans-Regular;
  max-width: ${getScaledValue(300)}px;
  margin-bottom: ${getScaledValue(30)}px;
`;
export const BannerButton = styled.TouchableHighlight.attrs(
  (props: { active?: boolean; theme: { primary: string } }) => ({
    underlayColor: props.theme.primary,
  }),
)`
  padding: ${getScaledValue(4)}px ${getScaledValue(8)}px;
  align-self: flex-start;
  border-radius: ${getScaledValue(3)}px;

  ${(props: { active?: boolean; theme: { primary: string } }) =>
    props.active
      ? `
            border-color: #ffffff;
            background-color: ${props.theme.primary};
            border-width: ${getScaledValue(2)}px;
        `
      : `
            background-color: #ffffff;
        `}

  flex-direction: row;
  align-items: center;
`;
export const BannerButtonIcon = styled(Icons).attrs(
  (props: { active?: boolean; theme: { primary: string } }) => ({
    width: getScaledValue(13),
    height: getScaledValue(13),
    icon: props.active ? 'play' : 'playblack',
    fill: !props.active ? '#35245D' : '#ffffff',
  }),
)`
  margin-right: ${getScaledValue(4)}px;
`;
export const BannerButtonText = styled.Text.attrs({})`
  font-size: ${getScaledValue(14)}px;
  color: #ffffff;
  font-family: PTSans-Bold;
  padding: 0 ${getScaledValue(4)}px;

  ${(props: { active?: boolean; theme: { primary: string } }) =>
    !props.active
      ? `
            color: #35245D;
        `
      : ``}
`;
